var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-form",
        { ref: "formAdditionalData" },
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        ref: "client_id",
                        attrs: {
                          label: "Client ID",
                          "prepend-inner-icon": "mdi-chevron-double-right",
                          rules: _vm.formRules,
                          required: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.client_id,
                          callback: function ($$v) {
                            _vm.client_id = $$v
                          },
                          expression: "client_id",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        ref: "client_secret",
                        attrs: {
                          label: "Client secret",
                          "prepend-inner-icon": "mdi-chevron-double-right",
                          rules: _vm.formRules,
                          required: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.client_secret,
                          callback: function ($$v) {
                            _vm.client_secret = $$v
                          },
                          expression: "client_secret",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "2" } },
                    [
                      _c("v-text-field", {
                        ref: "grant_type",
                        attrs: {
                          label: "Grant Type",
                          "prepend-inner-icon": "mdi-chevron-double-right",
                          rules: _vm.formRules,
                          disabled: true,
                          required: "",
                        },
                        model: {
                          value: _vm.grant_type,
                          callback: function ($$v) {
                            _vm.grant_type = $$v
                          },
                          expression: "grant_type",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "5" } },
                    [
                      _c("v-text-field", {
                        ref: "url_token",
                        attrs: {
                          label: "URL token",
                          "prepend-inner-icon": "mdi-chevron-double-right",
                          rules: _vm.formRules,
                          required: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.url_token,
                          callback: function ($$v) {
                            _vm.url_token = $$v
                          },
                          expression: "url_token",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "5" } },
                    [
                      _c("v-text-field", {
                        ref: "scope",
                        attrs: {
                          label: "Scope",
                          "prepend-inner-icon": "mdi-chevron-double-right",
                          rules: _vm.scopeFormRules,
                          clearable: "",
                        },
                        model: {
                          value: _vm.scope,
                          callback: function ($$v) {
                            _vm.scope = $$v
                          },
                          expression: "scope",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        ref: "Emisor",
                        attrs: {
                          label: "Código Emisor",
                          "prepend-inner-icon": "mdi-chevron-double-right",
                          type: "number",
                          clearable: "",
                          rules: _vm.emisorFormRules,
                          required: "",
                        },
                        model: {
                          value: _vm.emisor,
                          callback: function ($$v) {
                            _vm.emisor = $$v
                          },
                          expression: "emisor",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-select", {
                        ref: "Representation",
                        attrs: {
                          items: _vm.representationOptions,
                          "item-text": "textRepresentation",
                          "item-value": "valueRepresentation",
                          label: "Representación gráfica",
                          "prepend-inner-icon": "mdi-image",
                          rules: _vm.formRules,
                          required: "",
                        },
                        model: {
                          value: _vm.representation,
                          callback: function ($$v) {
                            _vm.representation = $$v
                          },
                          expression: "representation",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-alert",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.successAlert,
                      expression: "successAlert",
                    },
                  ],
                  attrs: { type: "success", text: "" },
                },
                [_vm._v(" " + _vm._s(_vm.msgSuccessAlert) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }